module.exports = __webpack_public_path__ + "static/media/steve-pili.2d42ef99.jpg";